export default __webpack_public_path__ + "static/media/2.cdd75774.jpg";